const initState = {
  css: {
    default: 'col-lg-2 col-md-3 col-sm-5',
    actions: 'col-lg-2 col-md-2 mb mb-actions center',
    activity: 'col-lg-1',
    expand: 'col-lg-1 col-md-2 mb expander',
    instructor: 'col-lg-1 col-md-3 col-sm-5',
    location: 'col-lg-2 col-md-2 mb mb-locations',
    session: 'col-lg-2 col-md-3 mb mb-session',
    start: 'col-lg-2 col-md-3 mb mb-start',
  },
  items: [],
};

export default (state = {}, action) => {
  const newState = { ...initState, ...state };
  switch (action.type) {
    default:
      return newState;
  }
};
